import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LinkPagamentoPage } from '@/features/link-pagamento/page/LinkPagamentoPage';

export const Route = createFileRoute('/p/pagamento/$id/')({
    component: Component,
    validateSearch: z.object({
        tipo: z.enum(['Boleto', 'Pix', 'Cartao']).optional(),
    }),
});

function Component() {
    const { id } = Route.useParams();

    return <LinkPagamentoPage id={id} />;
}
